import { API_NEW } from 'src/API';
import { WopiSettingsResponseType, EmbeddedParamsResponseType } from './types';

const API_ENDPOINTS = {
	/**
	 * Эндпоинт для получения настроек WOPI.
	 * Возвращает:
	 * - списки разрешённых расширений для просмотра (`possiblePreviewExtensionList`, `allowedViewExtensions`, `allowedEmbViewExtensions`)
	 * - список расширений для редактирования (`possibleEditExtensionList`, `allowedEditExtensions`)
	 * - флаг скрытия превью под спойлером (`isSpoilerPreview`)
	 */
	GET: '/wopi/GetSettings',
};

/** АПИ-класс с функциями запросами к сервису */
class API extends API_NEW {
	/** Запрос на настройки WOPI */
	static getSettings = async (): Promise<WopiSettingsResponseType> => {
		const res = await this.onRequest<WopiSettingsResponseType>({
			url: window.host + API_ENDPOINTS.GET,
		});
		if (res.statusCode === 200) {
			return res.result!;
		}
		return {
			...res,
			result: undefined,
		};
	};

	/** Запрос за параметрами предпросмотра */
	static getPreviewParams = async (
		fileId: string,
		attachmentId: string,
	): Promise<EmbeddedParamsResponseType> => {
		const qs = new URLSearchParams({
			fileId: attachmentId,
			deloid: fileId,
			action: 'embedview',
		}).toString();
		const res = await this.onRequest<EmbeddedParamsResponseType>({
			url: `${window.host}/wopi/GetEmbeddedParams?${qs}`,
		});
		if (res.statusCode === 200) {
			return res.result!;
		}
		return {
			...res,
			result: undefined,
		};
	};
}

export default API;
